import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {
  private messageSource = new BehaviorSubject('');
  public travelValueMobile = new BehaviorSubject<string>('');
  public returnValueMobile = new BehaviorSubject<string>('');
  public returnSearchValue = new BehaviorSubject<string>('');
  public returnPaymentValue = new BehaviorSubject<string>('');
  public successValue = new BehaviorSubject<string>('');
  public confirmValue = new BehaviorSubject<string>('');
  
  currentMessage = this.messageSource.asObservable();
  traveldateMobileChange = this.travelValueMobile.asObservable();
  returndateMobileChange = this.returnValueMobile.asObservable();
  returnSearchValueChange = this.returnSearchValue.asObservable();
  returnPaymentValueChange = this.returnPaymentValue.asObservable();
  successValueChange = this.successValue.asObservable();
  confirmValueChange = this.confirmValue.asObservable();
  changeMessage(message: string) {
    localStorage.setItem('searchFlights', message);
    this.messageSource.next(message)
  }
  changeTravelMessage(message: string) {
    this.travelValueMobile.next(message)
  }
  changeReturnMessage(message: string) {
    this.returnValueMobile.next(message)
  }
  changeSearchMessage(message: string) {
    this.returnSearchValue.next(message)
  }
  changePaymentMessage(message: string) {
    this.returnPaymentValue.next(message)
  }

  changeConfirmMessage(message: string) {
    this.confirmValue.next(message)
  }
  getTravelMessage(){
    return this.travelValueMobile.asObservable();
  }

  constructor() { }
}
